import progressGr16_202307 from './progress-gr1-6-2023-07/index.js'
import progressGr78_202307 from './progress-gr7-8-2023-07/index.js'
import provincialGr16_202309 from './provincial-gr1-6-2023-09/index.js'
import provincialGr78_202309 from './provincial-gr7-8-2023-09/index.js'
import provincialGr912_202202Sem from './provincial-gr9-12-2022-02-sem/index.js'
import kindergartenInitial_201606 from './kindergarten-initial-2016-06/index.js'
import kindergartenFinal_202309 from './kindergarten-final-2023-09/index.js'

const REGISTRY = {
  [progressGr16_202307.key]: progressGr16_202307,
  [progressGr78_202307.key]: progressGr78_202307,
  [provincialGr16_202309.key]: provincialGr16_202309,
  [provincialGr78_202309.key]: provincialGr78_202309,
  [provincialGr912_202202Sem.key]: provincialGr912_202202Sem,
  [kindergartenInitial_201606.key]: kindergartenInitial_201606,
  [kindergartenFinal_202309.key]: kindergartenFinal_202309,
}

export async function generatePdf(reportTypeKey, formData, options = {}) {
  const entry = REGISTRY[reportTypeKey]
  if (!entry) throw new Error(`Unknown report type: ${reportTypeKey}`)
  // fill signature is (formData, highlightRect, logos). The previous code passed
  // the whole options object as highlightRect (harmless: it lacked a pageIndex so
  // it no-op'd); now we destructure explicitly.
  const { highlightRect = null, logos = [] } = options
  return entry.fill(formData, highlightRect, logos)
}

export function getTemplateUrl(reportTypeKey) {
  return REGISTRY[reportTypeKey]?.templateUrl
}

export function getPageComponent(reportTypeKey) {
  return REGISTRY[reportTypeKey]?.Page
}
